import React, { useEffect, useState } from "react";
import {
    Box,
    Text
} from "@chakra-ui/react";
import BalanceCheck from "views/admin/balancecheck";
import { useLocation } from "react-router-dom";

export default function Report() {
    const location = useLocation();
    let clientId = null;
    let clientName = null;
    if (location.state != undefined) {
        clientId = location.state.agentId;
        clientName = location.state.agentName;
    }

    return (
        <>
            <BalanceCheck clientId={clientId} clientName={clientName} adminInvoke={true} nDays={7} />
        </>
    );
}
